import React, { memo } from 'react';
import styled from 'styled-components';
import { translate } from '../../../common/translation/translate';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';

export const BreakingNewsReadMore = memo(() => {
    return (
        <Container>
            <ReadMoreContent>
                {translate('readMore')}
            </ReadMoreContent>
        </Container>
    );
});

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    height: 35px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 20px;
    color: #FFF;
    bottom: 0;

    @media ${smallMediaQuery} {
        justify-content: flex-end;
        font-size: 16px;
        height: 30px;
    }
`;

const ReadMoreContent = styled.div`
    display: flex;
    justify-content: flex-start;
    width: auto;
    height: 35px;
    border-bottom: 3px solid #FFF;
    
    @media ${smallMediaQuery} {
        height: 30px;
        justify-content: flex-end;
    }
`;